<template>
    <div>
        <div v-if="!isLoading && vfairuserLoaded" class="vfairs-list">
            <div v-for="vfair in data" :key="vfair.id">
                <Paper tall>
                    <a style="text-decoration: none; position: relative" @click="gotoVFair(vfair)">
                        <div class="mainimagecontainer">
                            <img class="mainimage" :src="vfair.image || defaultBackground" />
                        </div>
                        <div class="h-200 clickable px-3 py-3 vfair-item">
                            <div class="mt-1 d-flex flex-column flex-grow justify-content-between">
                                <div class="flex-row-reverse">
                                    <span class="mb-4 gray-color">
                                        <h6 class="mb-3">
                                            {{ vfair.title }}
                                        </h6>
                                    </span>
                                    <h6 class="caption text-small mb-1 gray-color">
                                        <DateRange
                                            class="vfairdate"
                                            :start="vfair.start"
                                            :end="vfair.end"
                                        ></DateRange>
                                    </h6>
                                </div>
                            </div>

                            <div class="mt-1 d-flex flex-column justify-content-end">
                                <div class="d-flex flex-row justify-content-end">
                                    <OngoingBadge
                                        :start="vfair.start"
                                        :end="vfair.end"
                                    ></OngoingBadge>
                                    <span v-if="getInterested(vfair.id)"
                                        ><BaseIcon class="check" name="check"
                                    /></span>
                                </div>
                            </div>
                        </div>
                    </a>
                </Paper>
            </div>
        </div>
        <div v-else>
            <VFairListSkeleton />
        </div>
    </div>
</template>

<script>
// Utils
import VFairListSkeleton from '../../../../components/skeletons/VFairListSkeleton';
import DateRange from '../../components/DateRange';
import OngoingBadge from '../../components/OngoingBadge';
import moment from 'moment';
import defaultBackground from '~/assets/img/vcf/event-default-bg.png';

export default {
    name: 'VFairList',
    components: { VFairListSkeleton, DateRange, OngoingBadge },
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        isLoading: Boolean,
    },
    data() {
        return {};
    },
    computed: {
        vfairuser() {
            if (this.$interfaces.logInModule.isLoggedIn()) {
                return this.$interfaces.vfairuser.user.me.get({
                    reactive: true,
                });
            } else {
                return {
                    loaded: true,
                    data: [],
                };
            }
        },
        defaultBackground() {
            return defaultBackground;
        },
    },
    methods: {
        vfairuserData() {
            return this.vfairuser.data;
        },
        vfairuserLoaded() {
            return this.vfairuser.loaded;
        },
        getInterested(id) {
            let data = this.vfairuserData().filter(data => data.vfairId === id);
            if (data && data[0]) {
                return data[0].interested;
            }
            return false;
        },
        vFairRoute(vfair) {
            const start = moment(vfair.start);
            const end = moment(vfair.end);
            const active = moment().isBetween(start, end);
            if (active || localStorage.getItem('vfair_hack')) {
                return this.$URLS.vfair.concat('/', vfair.id);
            } else {
                return this.$URLS.vfairs.concat('/', vfair.id);
            }
        },
        gotoVFair(vfair) {
            this.$router.push(this.vFairRoute(vfair));
        },
    },
};
</script>

<style scoped>
.vfairs-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px;
}
.vfair-item {
    display: grid;
    grid-template-rows: repeat(auto);
    grid-template-columns: 1fr;
    grid-auto-flow: row;
    grid-column-gap: 1rem;
    grid-row-gap: 0.2rem;
    min-height: 160px;
}
@media only screen and (max-width: 600px) {
    .vfairs-list {
        grid-template-columns: 1fr;
        grid-auto-flow: row;
        overflow: scroll;
    }
}

.check {
    font-size: 18px;
    color: var(--primary);
}
.mainimagecontainer {
    width: 100%;
    padding-top: 87px;
    position: relative; /* If you want text inside of it */
}

.mainimage {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border-radius: 8px 8px 0 0;
    object-fit: cover;
}
.vfairdate {
    color: rgb(214, 29, 54);
    font-size: 12px;
}
</style>
